<template>
  <div :class="$style.svg" :title="desc">
    <SvgIcon width="14" height="14" :src="`icon-sprite-indicators.svg#${specKey}`" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import get from 'lodash/get';

import specs from '../common/specs';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { SvgIcon },
  props: {
    name: {
      type: String,
      required: true,
      validator: (name) => !!specs.find(({ db }) => db === name),
    },
  },
  computed: {
    specKey() {
      return get(this.spec, 'key');
    },
    spec() {
      return specs.find(({ db }) => db === this.name);
    },
    desc() {
      return get(this.spec, 'desc', `${this.name}: indicator icon not found`);
    },
  },
});
</script>

<style lang="scss" module>
.svg {
  width: 14px;
  height: 14px;
  svg {
    pointer-events: none;
    display: block;
  }
}
</style>
